<template>
  <div id="KenshinJudgment">
    <div id="container-center">
      <div class="labelTitle lable">検診結果判定</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>機種</th>
            <td><select id="kind" v-model="searchConditions.instrumentKind">
                <option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option>
              </select>
            </td>
          </tr>
        </table>
        <b-button class="is-primary startButton" @click="doStart">判定開始</b-button>
      </div>
      <template v-if="hasResult">
        <div class="labelTitle lable">判定結果入力</div>
        <div style="text-align: left; margin-top:10px;"><span style="font-weight:700;">判定医名：</span><input style="width:350px;" type="text" v-model="doctorName" maxlength="100"/></div>
        <div v-if="kindStr && kindStr.indexOf('ウォッチパット')!=-1" class="result-area typeWp">
          <div class="judgeString-area">A：正常範囲 B：要観察 C：要精密検査 Z：要治療 R：判定不能 </div>
          <div class="tableScroll-area">
            <b-table
              style="padding-right: 10px;"
              id="KenshinJudgmentTable"
              :data="resultList"
              :paginated="true"
              per-page="20"
              pagination-position="both"
              default-sort="user.first_name"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column field="receiptNumber" label="受付番号" width="80" centered>
                  <a @click="showDetail(props.row)">{{props.row.receiptNumber}}</a>
                </b-table-column>
                <b-table-column field="info" label="測定情報" width="80" centered >
                  <table class="innerTable">
                    <tr><th colspan="2">社員番号</th><th colspan="2">名前</th><th>性別</th><th class="font-small">生年月日</th><th>年齢</th><th>身長</th></tr>
                    <tr><td colspan="2">{{props.row.employeeNumber}}</td><td colspan="2">{{props.row.name}}</td><td>{{props.row.gender}}</td><td>{{props.row.birthday}}</td><td>{{props.row.age}}</td><td>{{props.row.height}}</td></tr>
                    <tr><th>体重</th><th>BMI</th><th class="font-small">検査ID</th><th class="font-small">開始日</th><th class="font-small">開始時間</th><th class="font-small">終了日</th><th class="font-small">終了時間</th><th class="font-small">測定時間</th></tr>
                    <tr><td>{{props.row.weight}}</td><td>{{props.row.bmi}}</td><td>{{props.row.inspectionId}}</td><td>{{props.row.startDate}}</td><td>{{props.row.startTime}}</td><td>{{props.row.endDate}}</td><td>{{props.row.endTime}}</td><td>{{props.row.measurementTime}}</td></tr>
                    <tr><th class="font-small">睡眠時間</th><th>ODI4</th><th>RDI</th><th>AHI</th><th class="font-small">SPO2中央</th><th class="font-small">SPO2最低</th><th class="font-small">脈拍平均</th><th class="font-small">脈拍最低</th></tr>
                    <tr><td>{{props.row.sleepTime}}</td><td>{{props.row.odi4}}</td><td>{{props.row.rdi}}</td><td>{{props.row.ahi}}</td><td>{{props.row.SPO2Center}}</td><td>{{props.row.SPO2Minimum}}</td><td>{{props.row.pulseAverage}}</td><td>{{props.row.pulseLowest}}</td>
                    <tr><th class="font-small">酸素90未満</th><th class="font-small">酸素88未満</th><th class="font-small">酸素85未満</th><th class="font-small">酸素80未満</th><th class="font-small">酸素70未満</th><th class="font-small">いびき40dB率</th><th class="font-small">セルフチェック</th></tr>
                    <tr><td>{{props.row.oxygenLess90}}</td><td>{{props.row.oxygenLess88}}</td><td>{{props.row.oxygenLess85}}</td><td>{{props.row.oxygenLess80}}</td><td>{{props.row.oxygenLess70}}</td><td>{{props.row.snoring40dBRate}}</td><td>{{props.row.selfCheck}}</td></tr>
                  </table>
                </b-table-column>
                <b-table-column field="judge" label="判定" width="60" centered>
                  <select class="judgeSelect" v-model="props.row.judgment">
                    <option></option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="Z">Z</option><option value="R">R</option>
                  </select>
                </b-table-column>
                <b-table-column field="comment" label="所見" width="130" centered>
                  <select class="commentSelect" :id="props.index" v-model="props.row.findings" @change="commentSelectInput(props.row)">
                    <option v-for="item in findingsSelectItems" :value="item.id" :key="item.id">{{ item.label }}</option>
                  </select>
                  <textarea class="comment" v-model="props.row.findingsMemo" maxlength="256" style="resize:vertical;max-width:100%;"></textarea>
                </b-table-column>
                <b-table-column field="judge" label="レポート" width="40" centered>
                  <ul v-for="(file,index) of props.row.analysisResultFileList" :key="index">
                    <a @click="downloadFile(file.fileAddress, file.fileId)"><b-icon icon="map-search-outline" size="is-medium"></b-icon></a>
                  </ul>
                </b-table-column>
              </template>
            </b-table>
          </div>
        </div>
        <div v-else class="result-area TypeOther">
          <div class="judgeString-area">A：正常範囲 B：要観察 C：要精密検査 R：判定不能</div>
          <div class="tableScroll-area">
            <b-table
              id="KenshinJudgmentTable"
              :data="resultList"
              :paginated="true"
              per-page="20"
              pagination-position="both"
              default-sort="user.first_name"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column field="receiptNumber" label="受付番号" width="80" centered>
                  <a @click="showDetail(props.row)">{{props.row.receiptNumber}}</a>
                </b-table-column>
                <b-table-column v-if="kindStr && kindStr.indexOf('サイモンJ')!=-1" field="info" label="測定情報" width="80" centered>
                  <table class="innerTable">
                    <tr><th colspan="2">社員番号</th><th colspan="2">名前</th><th>性別</th><th class="font-small">生年月日</th><th>年齢</th></tr>
                    <tr><td colspan="2">{{props.row.employeeNumber}}</td><td colspan="2">{{props.row.name}}</td><td>{{props.row.gender}}</td><td>{{props.row.birthday}}</td><td>{{props.row.age}}</td></tr>
                    <tr><th>身長</th><th>体重</th><th class="font-small">BMI</th><th class="font-small">患者ID</th><th class="font-small">測定日</th><th class="font-small">開始時刻</th><th class="font-small">測定時間</th></tr>
                    <tr><td>{{props.row.height}}</td><td>{{props.row.weight}}</td><td>{{props.row.bmi}}</td><td>{{props.row.inspectionId}}</td><td>{{props.row.startDate}}</td><td>{{props.row.startTime}}</td><td>{{props.row.measurementTime}}</td></tr>
                    <tr><th class="font-small">解析時間</th><th class="font-small">ODI3</th><th class="font-small">SPO2平均値</th><th class="font-small">SPO2最低値</th><th class="font-small">SPO2低下数</th><th class="font-small">脈拍平均</th><th class="font-small">セルフチェック</th></tr>
                    <tr><td>{{props.row.analysisTime}}</td><td>{{props.row.odi3}}</td><td>{{props.row.SPO2Center}}</td><td>{{props.row.SPO2Minimum}}</td><td>{{props.row.SPO2Declines}}</td><td>{{props.row.pulseAverage}}</td><td>{{props.row.selfCheck}}</td></tr>
                  </table>
                </b-table-column>
                <b-table-column v-else field="info" label="測定情報" width="80" centered>
                  <!-- <table class="innerTable">
                    <tr><th colspan="2">社員番号</th><th colspan="2">名前</th><th>性別</th><th class="font-small">生年月日</th><th>年齢</th><th>身長</th></tr>
                    <tr><td colspan="2">{{props.row.employeeNumber}}</td><td colspan="2">{{props.row.name}}</td><td>{{props.row.gender}}</td><td>{{props.row.birthday}}</td><td>{{props.row.age}}</td><td>{{props.row.height}}</td></tr>
                    <tr><th>体重</th><th class="font-small">BMI</th><th class="font-small">検査ID</th><th class="font-small">開始日</th><th class="font-small">開始時間</th><th class="font-small">終了日</th><th class="font-small">終了時間</th><th class="font-small">測定時間</th></tr>
                    <tr><td>{{props.row.weight}}</td><td>{{props.row.bmi}}</td><td>{{props.row.inspectionId}}</td><td>{{props.row.startDate}}</td><td>{{props.row.startTime}}</td><td>{{props.row.endDate}}</td><td>{{props.row.endTime}}</td><td>{{props.row.measurementTime}}</td></tr>
                    <tr><th class="font-small">睡眠時間</th><th class="font-small">ODI4</th><th class="font-small">ODI3</th><th class="font-small">ODI2</th><th class="font-small">SPO2中央</th><th class="font-small">SPO2最低</th><th class="font-small">脈拍中央</th><th class="font-small">&lt;90%時間</th></tr>
                    <tr><td>{{props.row.sleepTime}}</td><td>{{props.row.odi4}}</td><td>{{props.row.odi3}}</td><td>{{props.row.odi2}}</td><td>{{props.row.SPO2Center}}</td><td>{{props.row.SPO2Minimum}}</td><td>{{props.row.pulseAverage}}</td><td>{{props.row.lessThan90Time}}</td></tr>
                    <tr><th class="font-small">&lt;90%割合</th><th></th><th></th><th></th><th></th><th></th><th></th></tr>
                    <tr><td>{{props.row.lessThan90Ratio}}</td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                  </table> -->
                  <table class="innerTable">
                    <tr><th colspan="2">社員番号</th><th colspan="2">名前</th><th>性別</th><th class="font-small">生年月日</th><th>年齢</th></tr>
                    <tr><td colspan="2">{{props.row.employeeNumber}}</td><td colspan="2">{{props.row.name}}</td><td>{{props.row.gender}}</td><td>{{props.row.birthday}}</td><td>{{props.row.age}}</td></tr>
                    <tr><th>身長</th><th>体重</th><th class="font-small">BMI</th><th class="font-small">検査ID</th><th class="font-small">開始日</th><th class="font-small">開始時間</th><th class="font-small">終了日</th></tr>
                    <tr><td>{{props.row.height}}</td><td>{{props.row.weight}}</td><td>{{props.row.bmi}}</td><td>{{props.row.inspectionId}}</td><td>{{props.row.startDate}}</td><td>{{props.row.startTime}}</td><td>{{props.row.endDate}}</td></tr>
                    <tr><th class="font-small">終了時間</th><th class="font-small">測定時間</th><th class="font-small">睡眠時間</th><th class="font-small">ODI4</th><th class="font-small">ODI3</th><th class="font-small">ODI2</th><th class="font-small">SPO2中央</th></tr>
                    <tr><td>{{props.row.endTime}}</td><td>{{props.row.measurementTime}}</td><td>{{props.row.sleepTime}}</td><td>{{props.row.odi4}}</td><td>{{props.row.odi3}}</td><td>{{props.row.odi2}}</td><td>{{props.row.SPO2Center}}</td></tr>
                    <tr><th class="font-small">SPO2最低</th><th class="font-small">脈拍中央</th><th class="font-small">&lt;90%時間</th><th class="font-small">&lt;90%割合</th><th class="font-small">セルフチェック</th><th></th><th></th></tr>
                    <tr><td>{{props.row.SPO2Minimum}}</td><td>{{props.row.pulseAverage}}</td><td>{{props.row.lessThan90Time}}</td><td>{{props.row.lessThan90Ratio}}</td><td>{{props.row.selfCheck}}</td><td></td><td></td></tr>
                  </table>
                </b-table-column>
                <b-table-column field="judge" label="判定" width="60" centered>
                  <select class="judgeSelect" v-model="props.row.judgment">
                    <option></option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="R">R</option>
                  </select>
                </b-table-column>
                <b-table-column field="comment" label="所見" width="130" centered>
                  <select class="commentSelect" :id="props.index" v-model="props.row.findings" @change="commentSelectInput(props.row)">
                    <option v-for="item in findingsSelectItems" :value="item.id" :key="item.id">{{ item.label }}</option>
                  </select>
                  <textarea class="comment" v-model="props.row.findingsMemo" maxlength="256" style="resize:vertical;max-width:100%;"></textarea>
                </b-table-column>
                <b-table-column field="judge" label="レポート" width="40" centered>
                  <ul v-for="(file,index) of props.row.analysisResultFileList" :key="index">
                    <a @click="downloadFile(file.fileAddress, file.fileId)"><b-icon icon="map-search-outline" size="is-medium"></b-icon></a>
                  </ul>
                </b-table-column>
              </template>
            </b-table>
          </div>
        </div>
      </template>
      <div class="button-area" style="margin-top: 10px;">
        <b-button v-if="hasResult" class="is-primary" style="width:200px;" icon-left="content-save-outline" v-on:click="tempSaveJudgment" >一時保存する</b-button>
        <b-button v-if="hasResult" class="is-primary" style="width:200px;"  icon-left="cloud-upload-outline" v-on:click="sendJudgment" >判定内容を送信する</b-button>
        <b-button class="backButton is-primary" @click="back" >戻る</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import {choicesType} from "@/components/mock/base/const.js";
import {role} from "@/components/mock/base/const.js";

export default {
  name: "KenshinJudgment",
  methods: {
    doStart: function() {
      this.hasResult = false;
      // this.doctorName = "";
      if(!this.searchConditions.instrumentKind){
        // 機種が未選択の場合
        this.showErrorMessage("機種を選択してください")
        return;
      }
      var kind = this.modelList.find(val => val.value == this.searchConditions.instrumentKind)
      this.kindStr = kind.label1
      var excuteApi = this.getKenshinJudgmentStartPOST;
      var successCallBack = this.getKenshinJudgmentStartPOSTSuccess;
      var errorCallBack = this.getKenshinJudgmentStartPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinJudgmentStartPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.externalKenshinJudgment.getKenshinJudgmentStartPOST({
        body:obj
      });
    },
    getKenshinJudgmentStartPOSTSuccess: function(result) {
      // 検索結果取得
      this.resultList = result.obj
      if(this.resultList && this.resultList.length > 0){
        this.hasResult = true;
      }
    },
    getKenshinJudgmentStartPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    tempSaveJudgment: function() {
      var excuteApi = this.setKenshinJudgmentTempSavePOST;
      var successCallBack = this.setKenshinJudgmentTempSavePOSTSuccess;
      var errorCallBack = this.setKenshinJudgmentTempSavePOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinJudgmentTempSavePOST: function(client) {
      var obj = []
      this.resultList.map((val) =>{
        obj.push({
          id:val.id,
          receiptNumber:val.receiptNumber,
          judgment:val.judgment,
          findings:val.findings,
          findingsMemo:val.findingsMemo,
          doctorName:""
        })
      })
      return client.apis.externalKenshinJudgment.setKenshinJudgmentTempSavePOST({
        body:obj
      });
    },
    setKenshinJudgmentTempSavePOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
    },
    setKenshinJudgmentTempSavePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    sendJudgment: function() {
      var targetList = this.resultList.filter(val => val.judgment)
      if(!targetList || targetList.length < 1){
        this.showErrorMessage("判定結果を1件以上入力してください。");
        return
      }
      if(!this.doctorName){
        this.showErrorMessage("判定医名を入力してください");
        return
      }
      var messsage = "判定医名："+ this.doctorName+"<br>判定結果が入力されていないデータは送信されません。<br>よろしいでしょうか？";
      this.$dialog.confirm({
        title: "判定結果送信確認",
        message: messsage,
        confirmText:"はい",
        cancelText: "いいえ",
        onConfirm: async() => {
          var excuteApi = this.setKenshinJudgmentSendPOST;
          var successCallBack = this.setKenshinJudgmentSendPOSTSuccess;
          var errorCallBack = this.setKenshinJudgmentSendPOSTError;
          // Web Api Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack);
        }
      });
    },
    setKenshinJudgmentSendPOST: function(client) {
      var obj = []
      this.resultList.map((val) =>{
        obj.push({
          id:val.id,
          receiptNumber:val.receiptNumber,
          judgment:val.judgment,
          findings:val.findings,
          findingsMemo:val.findingsMemo,
          doctorName:this.doctorName
        })
      })
      return client.apis.externalKenshinJudgment.setKenshinJudgmentSendPOST({
        body:obj
      });
    },
    setKenshinJudgmentSendPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result,this.doStart());
    },
    setKenshinJudgmentSendPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    back: function() {
      //外部ユーザーホーム
      this.$router.push({ path: "/guest/home" });
    },
    showDetail(value) {
      this.$router.push({
        name: "KenshinJudgmentDetail",
        params: { 
          index: this.resultList.indexOf(value), 
          result: this.resultList,
          kind: this.kindStr,
          searchConditions: this.searchConditions,
          doctorName: this.doctorName
        }
      });
    },
    commentSelectInput: function(value) {
      var index = this.resultList.indexOf(value);
      var input = this.findingsSelectItems.find((item) => {return value.findings == item.id;});
      var inputLabel = input.label;
      if (inputLabel != "その他") {
        // その他以外
        this.resultList[index].findingsMemo = inputLabel;
      } else {
        // その他
        this.resultList[index].findingsMemo = "";
      }
    },
    getChoicesList: async function() {
      this.modelList = this.getChoiceList(this.choicesType.kenshinDevice, false);
      this.modelList.unshift({})
    },
    downloadFile: function(fileAddress, fileId){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getDownloadFilePOST({
            body:{
              fileId:fileId,
              fileName:fileAddress
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            let targetFile = fileAddress.toLowerCase();
            if(targetFile.endsWith(".pdf")){
                a.target="_blank"
            }
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      ); 
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var isJudgment = roleId == role.role_judgment;
    var doctorName = ""
    var searchConditions = {instrumentKind:"",judgementId: isJudgment ? userInfo.belongsId : null}
    var resultList = []
    var hasResult = false
    var kindStr = this.$route.params["kind"];
    if(this.$route.params["doctorName"]){
      doctorName = this.$route.params["doctorName"]
    }
    if(this.$route.params["searchConditions"]){
      searchConditions = this.$route.params["searchConditions"]
    }
    if(this.$route.params["result"]){
      resultList = this.$route.params["result"];
      hasResult = true
    }
    
    return {
      choicesType:choicesType,
      hasResult,
      searchConditions,
      kindStr,
      resultList,
      modelList:[],
      doctorName,
      findingsSelectItems: [
        { id: "0", label: "所見なし" },
        { id: "1", label: "測定時間の不足のため判定不可" },
        { id: "2", label: "センサー外れのため判定不可" },
        { id: "3", label: "その他" },
      ],
    };
  },
  filters: {},
  components: {},
  mounted: function() {
    // 機種マスタ取得
    this.getChoicesList();
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.condition-area {
  display: flex;
  align-items: center;
}
.conditionTable {
  width: 800px;
}
.startButton {
  margin-left: 30px;
}
.judgeString-area {
  text-align: left;
  margin-bottom: 10px;
}
.result-area {
  margin-top: 10px;
}
.tableScroll-area {
  max-height: 580px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.innerTable tr,
.innerTable th,
.innerTable td {
  height: 100%;
  border: 1px solid lightslategray;
  text-align: center;
}
.innerTable td {
  width:50px;
}
.judgeSelect {
  font-size: 30px;
}
.comment {
  width: 100%;
  height: 180px;
}
.font-small {
  font-size: 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/KenshinJudgment.vue